/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { proposalTalliesGetApiV3ProposalsProposalIdTallies } from "../../funcs/proposalTalliesGetApiV3ProposalsProposalIdTallies.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3ProposalsProposalIdTalliesRequest$inboundSchema,
};

export const tool$proposalTalliesGetApiV3ProposalsProposalIdTallies:
  ToolDefinition<typeof args> = {
    name: "proposal-tallies-get-api-v3-proposals-proposal-id-tallies",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await proposalTalliesGetApiV3ProposalsProposalIdTallies(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
